module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard4.1cdef3bb.webp";